module.exports = __webpack_public_path__ + "static/media/YB5F16_2.f0fd2399.jpg";